import React from 'react';

import styles from './Footer.module.css';

const date = new Date().toLocaleDateString();

export const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className="container">
        <div className={styles.footer_wrapper}>13.07.2024 - {date} </div>
      </div>
    </div>
  );
};
